import { render, staticRenderFns } from "./com-form-editor.vue?vue&type=template&id=70cc0b1a&"
import script from "./com-form-editor.vue?vue&type=script&lang=js&"
export * from "./com-form-editor.vue?vue&type=script&lang=js&"
import style0 from "./com-form-editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports